import Vue from 'vue';
import Vuex from 'vuex';

import ajax from '@/libs/ajax';

//import app from './modules/app';s
//import user from './modules/user';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        reqloading:false,
        userInfo:null,
    },
    mutations: {
        getuserinfo(state,data){
            //this.$store.commit("getuserinfo",{refresh:true});
            if(state.userInfo==undefined||(data&&data.refresh)){
                ajax.post(ajax.ajaxUrlPart + 'wxoauser/userinfo').then((result) => {
                    if(result.ret_code=='000100'){
                        state.userInfo = result;
                    }
                }).catch(err => {
                    //ajax.handleAjaxError(this, err);
                })
                // state.userInfo = {
                //     merchantName:"TestMerchant & Yuansfer",
                //     merchantNo:"200043",
                //     merchantAddress:"merchantAddress",
                // }
                // console.log(state.userInfo)
            }
        }
    },
    actions: {

    },
    modules: {
        //app,
        //user
    }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js